import axios from "axios";

const basicAxios = axios.create({
  timeout: 20000,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

export { basicAxios };
